import { useState, useEffect } from 'react'

import { getSubdistrictsAPI } from '../services/address'

function UseSubdistricts(id) {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getSubdistrictsAPI(id)
      if (!result) return

      const newData = result.result.length > 0 && result.result.map((d, i) => {
        return {
          value: d.DISTRICT_ID,
          label: d.DISTRICT_NAME,
          code: d.POST_CODE
        }
      })

      setData(newData)
    }
    if (id > 0) {
      getData()
    }
  }, [id])

  return data
}

export default UseSubdistricts
